import React, { useEffect } from 'react'
import './Services.css'
import CodeIcon from '@material-ui/icons/Code';
import MachineLearningIcon from '../../assets/machineLearning.png'
import WebDevIcon from '../../assets/WebDev.PNG'
import Service from './Service';
import "react-circular-progressbar/dist/styles.css";
import { useStateValue } from '../../StateProvider';
import Skill from './Skill';
import {useTranslation} from "react-i18next";


function Services() {
    const ServicesContainer = React.createRef();
    const [state, dispatch] = useStateValue();
    const {t, i18n} = useTranslation('common');
    useEffect(() => {
        dispatch({
            type : "ADD_REF",
            ref : ServicesContainer.current.offsetTop
        })
    }, [])
    return (
        <div ref={ServicesContainer} className="services">
            <h1>{ t('services.p1') }</h1>
            <div className="services__info">
                <Service src={WebDevIcon} title={ t('services.p2') } 
                description={ t('services.p3') }/>
                <Service src={MachineLearningIcon} title={ t('services.p4') } description={ t('services.p5') }/>
            </div>
            <div className="skills">
                <h2>{ t('services.p6') }</h2>
                <div className="row__skill">
                  <Skill prcntg={60} name="Python"/>
                  <Skill prcntg={50} name="Html/Css/Js"/>
                  <Skill prcntg={20} name="Bootstrap"/>
                  <Skill prcntg={50} name="React.js"/>
                  <Skill prcntg={20} name="Node.js"/>
                  <Skill prcntg={50} name="MySQL"/>
                  <Skill prcntg={10} name="PHP"/>
                  <Skill prcntg={10} name="Laravel"/>
                  <Skill prcntg={30} name="MongoDb"/>
                  <Skill prcntg={10} name="Django"/>
                  <Skill prcntg={30} name="ML"/>
                  <Skill prcntg={30} name="Kotlin"/>
                  <Skill prcntg={30} name="Java"/>
                  <Skill prcntg={10} name="Postgresql"/>
                  <Skill prcntg={10} name="Oracle"/>
                </div> 
            </div>
        </div>
    )
}

export default Services
